// http://redux-form.com/6.4.3/examples/fieldLevelValidation/
import EmailValidator from "email-validator";

export const required = value => (value ? undefined : "Required");

export const email = value =>
  EmailValidator.validate(value) ? undefined : "Invalid email";

export const at = value =>
  /@/.test(value) ? undefined : "Must contain @ symbol";



// WEBPACK FOOTER //
// ./src/app/validate.js